export const reportFailureInitialValues = () => ({
  referenceNumber: '',
  faliureType: '',
  solutionProviderName: '',
  technicalFailureDescription: '',
  supportingDocuments: [],
  technicalFailureDate: null,
  technicalFailureTime: '',
  expectedResolutionDate: null,
});

const mapDocumentsToFileUpload = (docs) =>
  (docs || []).map((doc) => ({
    name: doc.fileName,
    url: doc.filePath,
    size: doc.fileSize,
    type: doc.fileType,
  }));

export const resolveFailureInitialValues = (data) => ({
  failureNotificationId: data?.failureNotificationId || '',
  referenceNumber: data?.failureReferenceNumber || '',
  faliureType: data?.technicalFailureType || '',
  solutionProviderName: data?.solutionProviderName || '',
  technicalFailureDescription: data?.technicalFailureDescription || '',
  supportingDocuments: [],
  documents: mapDocumentsToFileUpload(data?.documents),
  technicalFailureDate: new Date(data?.technicalFailureDate),
  technicalFailureTime: data?.technicalFailureTime || '',
  expectedResolutionDate: new Date(data?.expectedResolutionDate),
  resolutionDate: data?.resolution?.resolutionDate
    ? new Date(data?.resolution?.resolutionDate)
    : null,
  resolutionTime: data?.resolution?.resolutionTime || '',
  resolutionSupportingDocuments: mapDocumentsToFileUpload(
    data?.resolution?.documents,
  ),
  additionalDetails: data?.resolution?.additionalInformation || '',
});
